import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectAppointments, updateSelectedAppontemnt } from '../store/appointmentSlice';
import { searchbarActions } from '../store';

export default function useClearAppointmentSelection() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { selectedAppontemnt } = useSelector(selectAppointments);

  useEffect(() => {
    if (
      location.pathname !== '/book-appointment' &&
      selectedAppontemnt
    ) {
      dispatch(updateSelectedAppontemnt(null));
      dispatch(searchbarActions.selectedSpecialityCode(null));
      dispatch(searchbarActions.selectedDoctorCode(null));
    }
  }, [location.pathname, selectedAppontemnt, dispatch]);
}